/**
 * Every element a tour may highlight. Registry-first like RuntimeFlag: markup
 * gets `{...tourAnchor(TourAnchor.X)}`, never a hand-written string, and tours
 * never target CSS classes (they break on refactors).
 */
export const TourAnchor = Object.freeze({
  HEADER_SEARCH: 'header.search',
  NAV_SHORTS: 'nav.shorts',
  NAV_GLOBE: 'nav.globe',
  NAV_CREATORS: 'nav.creators',
  NAV_WATCHLIST: 'nav.watchlist',
  AI_COMPOSER: 'ai.composer',
  AI_CHIPS: 'ai.chips',
  AI_GUIDE: 'ai.guide',
  AI_HISTORY: 'ai.history',
} as const);

export type TourAnchorId = (typeof TourAnchor)[keyof typeof TourAnchor];

export const TOUR_ANCHOR_ATTR = 'data-tour';

/** Spread onto the element a tour step points at. */
export function tourAnchor(id: TourAnchorId): { 'data-tour': TourAnchorId } {
  return { [TOUR_ANCHOR_ATTR]: id } as { 'data-tour': TourAnchorId };
}
